<script>
  import { Headline, Photo } from '@st-graphics/graphics-components';
  import { boolean } from '@st-graphics/graphics-kit/utils';

  let {
    navbar,
    headline,
    deck,
    byline,
    datetime,
    modifieddatetime,
    src,
    menuitems,
    crownalign = 'center',
    crownmaxwidth = 'unset',
    crownheight = '150px',
    mobiledeck = 'true',
    hasdesktop = 'false',
    maxwidth = '43.75rem',
    balancehed = true,
    balancedek = true,
  } = $props();

  const getExt = (filepath) => {
    const lastIndex = filepath.lastIndexOf('.');
    return filepath.slice(lastIndex + 1);
  };

  // TODO: add desktop/mobile options for the crown content
  // Add support for the svgfolder component and maybe video
</script>

{@render navbar?.()}

<div class="main-headline-head-wrapper crown">
  <div class="st-header-hero"></div>

  {@render menuitems?.()}

  <div
    class="wrap {crownalign}"
    style={`max-width: ${maxwidth}; height: ${crownheight}`}
  >
    {#if src}
      <div class="crown" style:max-width={crownmaxwidth}>
        {#if getExt(src) == 'svg'}
          <img src={`svg/${src}`} alt="" />
        {:else if getExt(src) == 'gif'}
          <img src={`images/${src}`} alt="" />
        {:else}
          <Photo {src} hasdesktop={boolean(hasdesktop)} alt="" />
        {/if}
      </div>
    {/if}
  </div>

  <div class="article-headline">
    <Headline
      hed={headline}
      dek={deck}
      {byline}
      {datetime}
      {modifieddatetime}
      mobiledeck={boolean(mobiledeck)}
      balancehed={boolean(balancehed)}
      balancedek={boolean(balancedek)}
    />
  </div>
</div>

<style lang="scss">
  .main-headline-head-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: fit-content;
    --headline-dek-color: currentcolor;
    --headline-metadata-color: currentcolor;

    .wrap {
      width: calc(100% - 30px);
      margin: 50px auto 40px auto;
      display: flex;
      align-items: center;
      overflow: hidden;

      &.left {
        justify-content: flex-start;
      }
      &.center {
        justify-content: center;
      }
      &.right {
        justify-content: flex-end;
      }
      .crown {
        width: 100%;
        height: 100%;
        img {
          height: 100%;
          width: 100%;
        }
      }
    }

    .article-headline {
      --headline-dek-color: currentcolor;
      --headline-metadata-color: currentcolor;
      --link-color: currentcolor;
      --link-text-decoration-color: currentcolor;
    }
  }
  :global(.crown .headline .wrapper:last-of-type) {
    border-bottom: 1px dotted
      var(--article-head-plain-headline-border-color, var(--st-medium-gray));
  }
</style>
